import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Modal, Table } from 'antd';
import { Table as ANNATable } from '@anna/anna-ws-ui';
import PropTypes from 'prop-types';
import mainStyles from '../Main/Main.module.css';
import styles from './Xero.module.scss';
import Header from '../Header';
import XeroAccountCell from './components/XeroAccountCell';
import {
  putXeroBankAccountMappingsActions,
  setActiveXeroBankAccountsAction,
  updateXeroBankAccountMappingRecordAction,
  resetXeroBankAccountMappingsAction,
} from '../../services/xeroService/actions';
import { history } from '../../utils/history';

class Xero extends Component {
  componentDidUpdate(prevProps) {
    const { xeroMappingsPushState: prevXeroMappingsPushState } = prevProps;
    const { xeroMappingsPushState } = this.props;
    if (prevXeroMappingsPushState !== xeroMappingsPushState && xeroMappingsPushState === 'success') {
      Modal.success({
        content: 'The mapping has been updated successfully.',
        onOk: this.close,
      });
    }
  }

  getColorByIndex = (index) => {
    const colors = [
      '#E9624E',
      '#17233A',
      '#959595',
    ];
    return colors[index % colors.length];
  };

  groupMappings = (xeroMappings) => {
    const { categories } = this.props;
    if (!xeroMappings || xeroMappings.length === 0) return [];
    if (!categories || categories.length === 0) return [];
    const cat = [];
    categories.forEach((group) => {
      cat.push({
        isGroup: true,
        id: group.id,
        groupName: group.group_name,
      });
      xeroMappings.forEach((mapping) => {
        if (group.categories.find((it) => it.id === mapping.category_id)) {
          cat.push(mapping);
        }
      });
    });
    return cat;
  }

  onAccountRowClick = (index, account) => {
    const { actions: { setActiveXeroBankAccount } } = this.props;
    setActiveXeroBankAccount(account);
  };

  renderAnnaCell = (record) => {
    if (record.isGroup) {
      return <div key={record.id} className={styles.CategoryGroup}>{record.groupName}</div>;
    }
    return (
      <div>
        {' '}
        {record.category_name}
        {' '}
      </div>
    );
  };

  renderXeroCell = (record) => {
    if (record.isGroup) {
      return <div />;
    }
    const { actions: { updateMappingRecord } } = this.props;
    return (
      <XeroAccountCell
        value={record}
        onAccountSelected={(xeroAccount) => {
          updateMappingRecord(record, xeroAccount);
        }}
      />
    );
  };

  getColumns = () => [
    {
      key: 1,
      title: 'ANNA Categories',
      render: (item, record) => this.renderAnnaCell(record),
    },
    {
      key: 2,
      title: 'Xero Accounts',
      render: (item, record) => this.renderXeroCell(record),
    },
  ];

  cancelSaveXeroMappings = () => {
    const { actions: { resetMappings } } = this.props;
    resetMappings();
    this.close();
  };

  close = () => {
    const { companyId } = this.props;
    history.push(`/company/${companyId}`);
  }

  saveXeroMappings = () => {
    const { actions: { saveXeroBankMappings } } = this.props;
    saveXeroBankMappings();
  };

  render() {
    const {
      accounts, selectedAccount, xeroMappings, xeroMappingsPushState, xeroMappingsLoadingState,
    } = this.props;

    const columns = [
      {
        title: 'Name',
        dataIndex: 'account_name',
        key: 'id',
        render: (value, record, index) => (
          <div className={styles.AccountsTableLabel}>
            <div
              style={{ backgroundColor: this.getColorByIndex(index) }}
              className={styles.AccountsTableDot}
            />
            {`${record.organisation_name} - ${record.account_name}`}
          </div>
        ),
      },
    ];

    const mappings = this.groupMappings(xeroMappings);

    const selectedAccountsIds = (selectedAccount && selectedAccount.id) || [];

    return (
      <div className={mainStyles.Main}>
        <Header />
        <div className={mainStyles.Body}>
          <div className={mainStyles.SidePanel}>
            <div className={styles.SidePanelGroup}>
              <div className={styles.Title}>Xero Companies</div>
              <Table
                className={styles.AccountsTable}
                showHeader={false}
                pagination={false}
                columns={columns}
                dataSource={accounts}
                rowKey="id"
                onRow={(record, rowIndex) => ({
                  onClick: () => this.onAccountRowClick(rowIndex, record),
                })}
                rowSelection={{
                  type: 'radio',
                  selectedRowKeys: selectedAccountsIds,
                  selections: true,
                }}
              />
            </div>
            <div className={styles.SidePanelTextGroup}>
              <p>
                Here you can change the mapping of Xero accounts to ANNA categories.
              </p>
              <p>
                If you want to change the mapping – select a Xero account from a menu on the right.
              </p>
              <p>
                <b>Keep in mind that </b>
                if there’re transactions in Xero that are already connected
                to an account, different from our default one – changing
                the mapping here will change that transactions’ account in Xero.
              </p>
            </div>
            <div className={styles.SidePanelButtonsGroup}>
              <Button
                type="default"
                icon="cancel"
                onClick={this.cancelSaveXeroMappings}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                icon="save"
                loading={xeroMappingsPushState === 'progress'}
                onClick={this.saveXeroMappings}
              >
                Save and exit
              </Button>
            </div>
          </div>
          <div className={mainStyles.Content}>
            <div className={styles.ContentTableWrapper}>
              <div className={styles.MappingTableTitle}>Accounts mapping</div>
              <ANNATable
                loading={xeroMappingsLoadingState === 'progress' || xeroMappingsPushState === 'progress'}
                rowKey={(record) => record.category_id || record.id}
                data={mappings}
                columns={this.getColumns()}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Xero.propTypes = {
  companyId: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    updateMappingRecord: PropTypes.func.isRequired,
    setActiveXeroBankAccount: PropTypes.func.isRequired,
    resetMappings: PropTypes.func.isRequired,
    saveXeroBankMappings: PropTypes.func.isRequired,
  }).isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  xeroMappingsPushState: PropTypes.string,
  xeroMappingsLoadingState: PropTypes.string,
  accounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedAccount: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  xeroMappings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

Xero.defaultProps = {
  xeroMappingsPushState: undefined,
  xeroMappingsLoadingState: undefined,
  selectedAccount: undefined,
};

const mapStateToProps = ({ xeroService, appService, categoriesService }) => ({
  accounts: xeroService.accounts,
  xeroAccounts: xeroService.xeroAccounts,
  selectedAccount: xeroService.selectedAccount,
  xeroMappings: xeroService.xeroMappings,
  xeroMappingsPushState: xeroService.xeroMappingsPushState,
  xeroMappingsLoadingState: xeroService.xeroMappingsLoadingState,
  companyId: appService.companyId,
  categories: categoriesService.categories,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    saveXeroBankMappings: putXeroBankAccountMappingsActions.common,
    setActiveXeroBankAccount: setActiveXeroBankAccountsAction,
    updateMappingRecord: updateXeroBankAccountMappingRecordAction,
    resetMappings: resetXeroBankAccountMappingsAction,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Xero);
